/* Foberry customizer - glass behaviours v8 */
(function () {
  if (window.__lgGlass) return;
  window.__lgGlass = true;
  var PH = window.__lgPH || '';
  var STEPS = [['01', 'Style'], ['02', 'Size'], ['03', 'Review & Buy']];
  var guides = [];
  var lgEdit = false, bypass = false, lastReset = 0;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var mqD = window.matchMedia ? window.matchMedia('(min-width:769px)') : { matches: true };

  function once(fn) {
    var q = false;
    return function () {
      if (q) return;
      q = true;
      raf(function () { q = false; try { fn(); } catch (e) { if (window.console) console.warn('[glass]', e); } });
    };
  }
  function addCls(el, c) { if (el && !el.classList.contains(c)) el.classList.add(c); }
  function delCls(el, c) { if (el && el.classList.contains(c)) el.classList.remove(c); }
  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function tgl(el, c, on) { if (!el) return; if (on) addCls(el, c); else delCls(el, c); }

  /* ---------- step tracker ---------- */
  function build(cls) {
    var ol = document.createElement('ol');
    ol.className = 'lg-steps ' + cls;
    ol.setAttribute('aria-label', 'Customizer progress');
    STEPS.forEach(function (s, i) {
      var li = document.createElement('li');
      li.className = 'lg-step';
      li.setAttribute('data-step', i + 1);
      li.setAttribute('role', 'button');
      li.tabIndex = 0;
      var n = document.createElement('span');
      n.className = 'n';
      n.textContent = s[0];
      var b = document.createElement('b');
      b.textContent = s[1];
      li.appendChild(n);
      li.appendChild(b);
      ol.appendChild(li);
    });
    return ol;
  }

  function currentStep() {
    var summary = $('.custom_summary_page');
    var sizes = $('.create-size');
    if (summary && !summary.classList.contains('hidden')) return 3;
    if (sizes && !sizes.classList.contains('hidden')) return 2;
    return 1;
  }

  function press(el) { if (!el) return; bypass = true; try { el.click(); } finally { bypass = false; } }
  function clearSummaryFlags() {
    delCls($('.btn-prev-tab'), 'summary-page');
    delCls($('.mono-prev-tab'), 'summary-page');
  }
  function jumpToSummary() {
    var m = $('.main-customizer-new');
    var nb = $('.btn-next-tab');
    if (!nb) return;
    var st = currentStep();
    if (st === 3) return;
    addCls(m, 'lg-jump');
    var done = function () { lgEdit = false; clearSummaryFlags(); setTimeout(function () { delCls(m, 'lg-jump'); }, 80); };
    if (st === 1) {
      press(nb);
      setTimeout(function () { if (currentStep() === 2) press(nb); done(); }, 0);
    } else {
      press(nb);
      done();
    }
  }

  function go(t) {
    var c = currentStep();
    if (t === c) return;
    if (c === 2 && t === 1) { press($('.btn-prev-tab')); return; }
    if (c === 1 && t === 2) {
      var nb = $('.btn-next-tab');
      if (nb && !nb.classList.contains('disabled') && !nb.classList.contains('hidden')) press(nb);
      else guideMissing();
      return;
    }
    if (c === 3 && t === 2) { var se = $('.summary_sizes .edit-btn'); if (se) se.click(); return; }
    if (c === 3 && t === 1) { var ye = $('.summary_style .edit-btn'); if (ye) ye.click(); }
  }

  /* ---------- messages / missing fields ---------- */
  var toast = null, toastTimer = null, lastDisabled = true;
  function hideToast() {
    if (toast) { delCls(toast, 'is-on'); delCls(toast, 'is-err'); }
    delCls($('.btn-next-tab'), 'lg-pulse');
  }
  function say(text, err, ms) {
    var host = document.getElementById('fullscreen-modal') || document.body;
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lg-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      host.appendChild(toast);
    }
    toast.textContent = text;
    tgl(toast, 'is-err', !!err);
    addCls(toast, 'is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, ms || 3600);
  }
  function flash(el) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
    addCls(el, 'lg-missing');
    setTimeout(function () { delCls(el, 'lg-missing'); }, 1800);
  }
  function titleOf(el) {
    var t = el && ($('.title', el) || $('.swatch-title', el) || $('label', el));
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function paneKind(pane) {
    var list = $('.create-size-list');
    var a = pane && pane.id && list && $('a[href="#' + pane.id + '"]', list);
    return a ? a.getAttribute('data-lg') : '';
  }
  function groupReq(g, pane) {
    var ins = $$('input', g);
    if (ins.some(function (i) { return i.required; })) return true;
    if (!$('[required]', pane || g) && paneKind(pane) === 'standard') return true;
    return false;
  }

  function guideMissing() {
    var st = currentStep();
    if (st === 1) {
      var cards = $$('.overview-list .required').map(function (b) { return b.closest('li'); }).filter(function (li) {
        return li && li.offsetParent !== null && !li.classList.contains('selected_options') && !$('a.select,.option-card.select', li);
      });
      if (cards.length) {
        flash(cards[0]);
        say('Please choose: ' + (titleOf(cards[0]) || 'a required option'), true);
      } else {
        say('Please finish the current selection first.', true);
      }
      return;
    }
    if (st !== 2) return;
    var s = $('.create-size');
    if (!s) return;
    if (s.getAttribute('data-lg-view') !== 'panel') {
      flash($('.create-size-list', s));
      say('Choose how you would like to give your size.', true);
      return;
    }
    var pane = $('.tab-pane.active', s) || $('.tab-pane.show', s);
    if (!pane) return;
    var target = null, label = '';
    $$('.measure-list > li', pane).some(function (li) {
      var tag = $('.optional-or-required-tag', li), inp = $('input[type=number],input[type=text]', li);
      if (tag && tag.classList.contains('required') && inp && !inp.value.trim()) { target = li; label = titleOf(li); return true; }
      return false;
    });
    if (!target) {
      $$('.standard-sizes, .choose-swatch', pane).some(function (g) {
        if ($('li', g) && groupReq(g, pane) && !$('input:checked', g)) { target = g; label = titleOf(g); return true; }
        return false;
      });
    }
    if (target) {
      flash(target);
      var inp2 = $('input[type=number],input[type=text]', target);
      if (inp2 && mqD.matches) { try { inp2.focus({ preventScroll: true }); } catch (e) { inp2.focus(); } }
      say('Please add: ' + (label || 'a required field'), true);
    } else if (paneKind(pane) === 'smart') {
      say('Please answer all the questions to continue.', true);
    } else {
      say('Please complete the required sizes to continue.', true);
    }
  }

  /* ---------- fresh start (Start Again + after Add To Bag) ---------- */
  function hardClear() {
    var m = $('.main-customizer-new');
    if (!m) return;
    $$('input[type=radio]:checked,input[type=checkbox]:checked', m).forEach(function (i) { i.checked = false; });
    $$('.measure-list input,.custom_answer input,.letter-inputs input,input[name="properties[monogram text]"]', m).forEach(function (i) {
      if (i.type !== 'radio' && i.type !== 'checkbox') i.value = '';
    });
    $$('.measure-list > li > .optional-or-required-tag', m).forEach(function (t) {
      delCls(t, 'is-added');
      if (t.dataset.lgOrig) setText(t, t.dataset.lgOrig);
    });
    $$('.select,.selected_options,.is-guide,.lg-missing', m).forEach(function (el) {
      delCls(el, 'select'); delCls(el, 'selected_options'); delCls(el, 'is-guide'); delCls(el, 'lg-missing');
      if (el.hasAttribute && el.hasAttribute('applied-charge')) el.removeAttribute('applied-charge');
    });
    var pb = $('#previewBox');
    if (pb) pb.textContent = 'A B C';
    var cm = document.getElementById('comments');
    if (cm) cm.value = '';
    $$('.total_quantity').forEach(function (q) { q.value = '1'; });
    if (typeof window.__removeCustomizerChildLists === 'function') { try { window.__removeCustomizerChildLists(); } catch (e) {} }
    addCls($('.custom_summary_page'), 'hidden');
    $$('.hide_selection').forEach(function (el) { delCls(el, 'hidden'); });
    $$('.custom_hide').forEach(function (el) { delCls(el, 'custom_hide'); });
    addCls($('.create-size'), 'hidden');
    delCls($('.overview'), 'hidden');
    delCls(document.getElementById('myTabContent'), 'hidden');
    $$('.custom_monogram').forEach(function (el) { addCls(el, 'hidden'); });
    lgEdit = false;
    clearSummaryFlags();
    setView('select');
    hideToast();
    paint();
  }
  function resetAll() {
    var now = Date.now();
    if (now - lastReset < 2500) return;
    lastReset = now;
    var sb = $('.start-button');
    if (sb) { bypass = true; try { sb.click(); } catch (e) {} bypass = false; }
    setTimeout(hardClear, 120);
    setTimeout(hardClear, 700);
  }
  function hookCart() {
    document.addEventListener('cart:update', function (e) {
      var d = e && e.detail && e.detail.data;
      if (d && d.source === 'custom-script') setTimeout(resetAll, 700);
    });
    if (window.fetch && !window.fetch.__lg) {
      var of = window.fetch;
      window.fetch = function (u, o) {
        var p = of.apply(this, arguments);
        try {
          var url = (typeof u === 'string' ? u : (u && u.url)) || '';
          var method = (o && o.method) || (u && u.method) || 'GET';
          if (/\/cart\/add/.test(url) && /post/i.test(method)) {
            p.then(function (r) { if (r && r.ok && $('.main-customizer-new')) setTimeout(resetAll, 900); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
      window.fetch.__lg = 1;
    }
  }

  /* ---------- size chart / guide image popup (centred, with close) ---------- */
  var lb = null;
  function closeZoom() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.add('is-closing');
    setTimeout(function () { lb.classList.remove('is-open', 'is-closing'); }, 240);
  }
  function openSrc(src, cap) {
    if (!src) return;
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'lg-lightbox';
      lb.innerHTML = '<div class="lg-lightbox-card"><button type="button" class="lg-x" aria-label="Close"></button><img alt=""><div class="lg-lightbox-cap"></div></div>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || (e.target.closest && e.target.closest('.lg-x'))) closeZoom();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }
    $('img', lb).src = src;
    $('.lg-lightbox-cap', lb).textContent = cap || '';
    lb.classList.remove('is-closing');
    lb.classList.add('is-open');
  }

  /* one capture-phase click router (runs before the theme's own handlers) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var li = t.closest('.lg-step');
    if (li) { go(parseInt(li.getAttribute('data-step'), 10)); return; }
    var box = t.closest('.lg-guide-img');
    if (box) {
      var gim = $('img', box);
      if (gim && gim.getAttribute('src')) openSrc(gim.currentSrc || gim.src, ($('.lg-guide-t', box.closest('.lg-guide')) || {}).textContent);
      return;
    }
    var pop = t.closest('.popup');
    if (pop && pop.closest('.create-size')) {
      var pim = $('img.popupimg', pop) || $('#myPopup', pop);
      if (pim) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openSrc(pim.getAttribute('src'), 'Size Guide');
        return;
      }
    }
    var ed = t.closest('.edit-btn');
    if (ed && ed.closest('.custom_summary_page')) { lgEdit = !ed.classList.contains('sizes'); return; }
    if (t.closest('.start-button')) {
      lgEdit = false;
      if (!bypass) { setTimeout(clearSummaryFlags, 0); setTimeout(hardClear, 150); setTimeout(hardClear, 600); }
      return;
    }
    var nb = t.closest('.btn-next-tab');
    if (nb) {
      if (bypass) return;
      if (nb.classList.contains('disabled') && !nb.classList.contains('hidden')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        guideMissing();
        return;
      }
      if (lgEdit && currentStep() === 1) setTimeout(function () { if (currentStep() === 2) jumpToSummary(); }, 0);
      return;
    }
    if (t.closest('.btn-prev-tab,.mono-prev-tab,.mono-prev-addons')) {
      setAttr($('.product_form_wrapper'), 'data-lg-dir', 'back');
      setTimeout(clearSummaryFlags, 0);
      return;
    }
    if (t.closest('.overview-list a,.option-card,.customizer-list label')) {
      setAttr($('.product_form_wrapper'), 'data-lg-dir', 'fwd');
    }
    if (lgEdit && t.closest('.apply_mono_btn,.apply-mono-addons')) {
      setTimeout(function () { if (currentStep() === 1 && lgEdit) jumpToSummary(); }, 350);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var li = e.target.closest && e.target.closest('.lg-step');
    if (li) { e.preventDefault(); go(parseInt(li.getAttribute('data-step'), 10)); }
  });

  function sync() {
    var s = $('.create-size'), m = $('.main-customizer-new');
    if (!s || !m) return;
    var on = currentStep() === 2 && s.getAttribute('data-lg-view') === 'panel' && s.getAttribute('data-guide') === 'on';
    tgl(m, 'lg-guide-on', on);
  }

  function paintNow() {
    var c = currentStep();
    $$('.lg-steps .lg-step').forEach(function (li) {
      var n = parseInt(li.getAttribute('data-step'), 10);
      tgl(li, 'is-active', n === c);
      tgl(li, 'is-done', n < c);
      if (n === c) setAttr(li, 'aria-current', 'step'); else if (li.hasAttribute('aria-current')) li.removeAttribute('aria-current');
    });
    sync();
    if (c === 3) { lgEdit = false; clearSummaryFlags(); enhanceSummary(); enhanceMono(); }
    if (c !== 2) hideToast();
  }
  var paint = once(paintNow);

  /* ---------- measuring guide ---------- */
  function mkGuide(cls) {
    var d = document.createElement('div');
    d.className = 'lg-guide ' + cls;
    d.innerHTML = '<div class="lg-guide-img"><img alt="" decoding="async"><button type="button" class="lg-zoom-btn" aria-label="Enlarge image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"></path></svg></button></div><div class="lg-guide-body"><span class="lg-guide-k">Measuring guide</span><b class="lg-guide-t"></b><p class="lg-guide-d"></p></div>';
    guides.push(d);
    return d;
  }

  function read(li) {
    if (li.__lg) return li.__lg;
    var m = $('.modal', li), lab = $('label', li);
    var t = m && $('.modal-title', m), d = m && $('.additional_popup_details', m), im = m && $('.modal-img img', m);
    li.__lg = {
      t: (t && t.textContent.trim()) || (lab && lab.textContent.trim()) || '',
      d: (d && d.textContent.trim()) || '',
      i: (im && im.getAttribute('src')) || ''
    };
    return li.__lg;
  }

  function setGuide(li) {
    var s = $('.create-size');
    if (!s || !li) return;
    var g = read(li);
    $$('.measure-list > li.is-guide', s).forEach(function (x) { if (x !== li) delCls(x, 'is-guide'); });
    addCls(li, 'is-guide');
    guides.forEach(function (el) {
      setText($('.lg-guide-t', el), g.t);
      var p = $('.lg-guide-d', el);
      setText(p, g.d);
      p.style.display = g.d ? '' : 'none';
      var im = $('img', el), src = g.i || PH;
      if (src && im.getAttribute('src') !== src) {
        im.style.opacity = 0;
        im.onload = function () { im.style.opacity = 1; };
        im.onerror = function () { if (PH && im.getAttribute('src') !== PH) im.src = PH; else im.style.opacity = 1; };
        im.src = src;
      }
    });
    setAttr(s, 'data-guide', 'on');
    sync();
  }

  function refreshGuide() {
    var s = $('.create-size');
    if (!s) return;
    var li = $('.tab-pane.active .measure-list > li', s);
    if (li && s.getAttribute('data-lg-view') === 'panel') {
      setGuide($('.measure-list > li.is-guide', li.parentNode) || li);
    } else {
      setAttr(s, 'data-guide', 'off');
      sync();
    }
  }

  function setView(v) {
    var s = $('.create-size');
    if (!s) return;
    setAttr(s, 'data-lg-view', v);
    var row = $('.create-sizes-row', s);
    if (row) row.scrollTop = 0;
    if (v === 'panel') refreshGuide(); else setAttr(s, 'data-guide', 'off');
    sync();
  }

  /* ---------- sizing helpers ---------- */
  function kindOf(t) {
    t = (t || '').toLowerCase();
    if (t.indexOf('smart') > -1) return 'smart';
    if (t.indexOf('standard') > -1) return 'standard';
    if (t.indexOf('shirt') > -1) return 'shirt';
    if (t.indexOf('body') > -1) return 'body';
    return 'other';
  }

  /* group tag shows only what was chosen (e.g. 15.5 / Slim), green; otherwise Required (red) / Optional (teal) */
  function groupTags(s) {
    $$('.tab-pane', s).forEach(function (pane) {
      $$('.standard-sizes, .choose-swatch', pane).forEach(function (g) {
        var title = $('.swatch-title', g);
        if (!title || !$('li', g)) return;
        var req = groupReq(g, pane), c = $('input:checked', g);
        setAttr(title, 'data-lg-state', c ? 'added' : (req ? 'required' : 'optional'));
        setAttr(title, 'data-lg-tag', c ? String(c.value) : (req ? 'Required' : 'Optional'));
      });
    });
  }

  function fixTags(s) {
    $$('.measure-list > li', s).forEach(function (li) {
      var tag = $('.optional-or-required-tag', li);
      if (!tag) return;
      var inp = $('input[type=number],input[type=text]', li);
      if (!tag.dataset.lgOrig) {
        var t = tag.textContent.trim().toLowerCase();
        var kind = tag.classList.contains('required') ? 'required' : (tag.classList.contains('optional') ? 'optional' : (t.indexOf('required') > -1 ? 'required' : (t.indexOf('optional') > -1 ? 'optional' : ((inp && inp.required) ? 'required' : 'optional'))));
        delCls(tag, kind === 'required' ? 'optional' : 'required');
        addCls(tag, kind);
        tag.dataset.lgOrig = kind === 'required' ? 'Required' : 'Optional';
        setText(tag, tag.dataset.lgOrig);
      }
    });
    $$('.choose-swatch', s).forEach(function (c) { if (!$('li', c)) c.style.display = 'none'; });
    $$('.smart_sizes_lis', s).forEach(function (l) { if ($('img', l)) addCls(l, 'lg-img'); });
    groupTags(s);
  }
  /* filled => the tag turns green and shows the value (e.g. "55 in"); cleared => back to Required / Optional */
  function markAdded(inp) {
    var li = inp.closest && inp.closest('.measure-list > li');
    var t = li && $('.optional-or-required-tag', li);
    if (!t) return;
    if (!t.dataset.lgOrig) fixTags($('.create-size'));
    var v = inp.value.trim();
    if (v) {
      var u = $('.measuring-scale', li);
      setText(t, v + (u && u.textContent.trim() ? ' ' + u.textContent.trim() : ''));
      addCls(t, 'is-added');
    } else {
      delCls(t, 'is-added');
      if (t.dataset.lgOrig) setText(t, t.dataset.lgOrig);
    }
  }
  function markAll(s) {
    fixTags(s);
    $$('.measure-list input[type=number],.measure-list input[type=text]', s).forEach(markAdded);
  }

  /* ---------- "size added -> Review & Buy" prompt ---------- */
  function watchNext() {
    var b = $('.btn-next-tab');
    if (!b || b.__lgw) return;
    b.__lgw = 1;
    lastDisabled = b.classList.contains('disabled');
    new MutationObserver(function () {
      var d = b.classList.contains('disabled');
      if (d === lastDisabled) return;
      lastDisabled = d;
      var s = $('.create-size');
      if (!d && currentStep() === 2 && s && s.getAttribute('data-lg-view') === 'panel') {
        var label = (b.textContent || 'Next').trim();
        say('Size added \u2014 tap \u201c' + label + '\u201d below to Review & Buy', false, 7000);
        addCls(b, 'lg-pulse');
      } else if (d) hideToast();
    }).observe(b, { attributes: true, attributeFilter: ['class'] });
    b.addEventListener('click', hideToast);
  }

  var updLast = once(function () {
    var s = $('.create-size');
    if (!s) return;
    var qs = $$('.question_sizes', s), idx = -1;
    qs.forEach(function (q, i) { if (idx < 0 && !q.classList.contains('hidden')) idx = i; });
    tgl(s, 'lg-last', qs.length > 0 && idx === qs.length - 1);
  });

  function initSize(s) {
    if (s.getAttribute('data-lg-init')) return;
    s.setAttribute('data-lg-init', '1');
    s.setAttribute('data-lg-view', 'select');
    s.setAttribute('data-guide', 'off');
    var row = $('.create-sizes-row', s), list = $('.create-size-list', s), tc = $('.tab-content', s);
    if (!row || !list || !tc) return;

    $$('a', list).forEach(function (a) {
      var k = kindOf(a.textContent);
      a.setAttribute('data-lg', k);
      if (a.parentNode) a.parentNode.setAttribute('data-lg', k);
    });
    $$('.popup .custom-size', s).forEach(function (el) {
      var n = el.firstChild;
      if (n && n.nodeType === 3) n.nodeValue = 'Size Guide';
    });

    var intro = document.createElement('p');
    intro.className = 'lg-size-intro';
    intro.textContent = 'Choose how you would like to give us your size.';
    s.insertBefore(intro, row);

    var head = document.createElement('div');
    head.className = 'lg-size-head';
    head.innerHTML = '<button type="button" class="lg-back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>Change method</button><span class="lg-size-title"></span>';
    row.insertBefore(head, tc);
    row.insertBefore(mkGuide('lg-guide--inline'), tc);
    var title = $('.lg-size-title', head);
    $('.lg-back', head).addEventListener('click', function () { setView('select'); });

    list.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      setTimeout(function () { title.textContent = a.textContent.trim(); setView('panel'); markAll(s); updLast(); }, 0);
    });

    $$('.question_sizes', s).forEach(function (q) {
      new MutationObserver(updLast).observe(q, { attributes: true, attributeFilter: ['class'] });
    });
    updLast();

    s.addEventListener('focusin', function (e) {
      var li = e.target.closest && e.target.closest('.measure-list > li');
      if (li) setGuide(li);
    });
    s.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches('.measure-list input')) markAdded(e.target);
    });
    s.addEventListener('click', function (e) {
      var ib = e.target.closest && e.target.closest('.measure-list .info_btn');
      if (ib) {
        e.preventDefault();
        e.stopPropagation();
        var li = ib.closest('li');
        setGuide(li);
        if (mqD.matches) {
          var inp = $('input', li);
          if (inp) inp.focus({ preventScroll: true });
        } else {
          var g = $('.lg-guide--inline', s);
          if (g && g.scrollIntoView) g.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }
      setTimeout(function () { groupTags(s); }, 0);
    });
    s.addEventListener('change', function () { setTimeout(function () { markAll(s); }, 0); });
  }

  /* ---------- search inside option lists ---------- */
  function norm(x) { return (x || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function attachSearch(ul) {
    var w = document.createElement('div');
    w.className = 'lg-search';
    w.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg><input type="search" placeholder="Search" aria-label="Search options" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search"><span class="lg-search-n"></span><button type="button" class="lg-search-x" aria-label="Clear search">&times;</button>';
    var empty = document.createElement('div');
    empty.className = 'lg-search-empty';
    empty.textContent = 'No matches found';
    ul.insertBefore(w, ul.firstChild);
    ul.appendChild(empty);
    var inp = $('input', w), cnt = $('.lg-search-n', w), timer = null;
    function run() {
      var q = norm(inp.value), n = 0, kids = ul.children;
      for (var i = 0; i < kids.length; i++) {
        var li = kids[i];
        if (li.tagName !== 'LI') continue;
        if (li.__t === undefined) li.__t = norm((li.querySelector('.selection') || li).textContent);
        var hit = !q || li.__t.indexOf(q) !== -1;
        if (hit) li.removeAttribute('data-lg-hide'); else li.setAttribute('data-lg-hide', '1');
        if (hit) n++;
      }
      tgl(w, 'has-q', !!q);
      cnt.textContent = q ? n + ' found' : '';
      empty.style.display = q && !n ? 'block' : 'none';
    }
    inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Escape') { inp.value = ''; run(); } });
    $('.lg-search-x', w).addEventListener('click', function () { inp.value = ''; run(); inp.focus(); });
  }
  function initSearchNow() {
    $$('.overview ul.childs-list').forEach(function (ul) {
      if (ul.__lgs || ul.children.length < 9) return;
      ul.__lgs = 1;
      attachSearch(ul);
    });
  }
  var initSearch = once(initSearchNow);

  /* ---------- summary: image cards ---------- */
  function names(v) { return v.split(/\s*(?:,|\||\u2022|\+|;)\s*/).filter(Boolean); }
  function okUrl(u) { return !!u && /^(https?:)?\/\/|^\//i.test(u); }
  function enhanceSummary() {
    [['.summary_style', 'styles'], ['.summary_additional', 'contrasts']].forEach(function (p) {
      var box = $(p[0]);
      if (!box) return;
      var lis = $$('li.selected_options').filter(function (li) { return li.getAttribute('childsin') === p[1]; });
      $$('.tag', box).forEach(function (tag, i) {
        if (tag.classList.contains('lg-sum')) return;
        var li = lis[i], edit = $('.edit-btn', tag);
        if (!li || !edit) return;
        var value = tag.textContent.replace(edit.textContent, '').trim();
        var parts = names(value), multi = parts.length > 1;
        var te = $('.title', li), pTitle = te ? te.textContent.trim() : '';
        var imgEl = multi ? ($('.org_img img', li) || $('.select_img img', li)) : ($('.select_img img', li) || $('.org_img img', li));
        var src = imgEl && (imgEl.currentSrc || imgEl.getAttribute('src'));
        tag.classList.add('lg-sum');
        tag.textContent = '';
        var fig = document.createElement('span');
        fig.className = 'lg-sum-img';
        if (src) {
          var im = document.createElement('img');
          im.alt = '';
          im.loading = 'lazy';
          im.decoding = 'async';
          im.src = src;
          fig.appendChild(im);
        }
        var body = document.createElement('span');
        body.className = 'lg-sum-body';
        var label = multi ? pTitle : (pTitle && pTitle !== parts[0] ? pTitle : '');
        if (label) {
          var k = document.createElement('span');
          k.className = 'lg-sum-k';
          k.textContent = label;
          body.appendChild(k);
        }
        var t = document.createElement('b');
        t.className = 'lg-sum-t';
        t.textContent = multi ? (parts.length + ' selections') : (parts[0] || value);
        body.appendChild(t);
        if (multi) {
          var mq = document.createElement('span');
          mq.className = 'lg-marquee';
          var tr = document.createElement('span');
          tr.className = 'lg-marquee-track';
          var txt = parts.join('   \u2022   ');
          tr.textContent = txt + '   \u2022   ' + txt + '   \u2022   ';
          mq.appendChild(tr);
          body.appendChild(mq);
        }
        tag.appendChild(fig);
        tag.appendChild(body);
        tag.appendChild(edit);
      });
    });
  }

  function enhanceMono() {
    var box = $('.summary_monogram');
    if (!box) return;
    var mc = $('.custom_monogram');
    $$('.tag', box).forEach(function (tag) {
      if (tag.classList.contains('lg-sum')) return;
      var edit = $('.edit-btn', tag);
      if (!edit) return;
      var raw = tag.textContent.replace(edit.textContent, '').trim();
      var fig = document.createElement('span');
      fig.className = 'lg-sum-img';
      var kind, title, value;
      if (/^Text:/i.test(raw)) {
        title = 'Monogram text';
        value = raw.replace(/^Text:\s*/i, '');
        fig.classList.add('is-text');
        fig.textContent = value.replace(/\s+/g, '');
        var pb = $('#previewBox');
        if (pb) { fig.style.fontFamily = pb.style.fontFamily || ''; fig.style.color = pb.style.color || ''; }
      } else {
        var m = raw.match(/monogram_([a-z]+)\]?:\s*(.*)$/i);
        kind = m ? m[1].toLowerCase() : 'other';
        value = m ? m[2] : raw;
        title = 'Monogram ' + kind;
        var inp = mc && $('input[name="properties[monogram_' + kind + ']"]:checked', mc);
        var src = '';
        if (inp) {
          src = inp.getAttribute(kind === 'font' ? 'font-img' : 'data-image') || '';
          if (!okUrl(src)) {
            var lab = (inp.id && $('label[for="' + inp.id + '"]', mc)) || (inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null);
            var li2 = lab && $('.img img', lab);
            src = li2 ? (li2.currentSrc || li2.getAttribute('src') || '') : '';
          }
        }
        var col = inp && inp.getAttribute('data-color');
        if (kind === 'color' && col) {
          fig.classList.add('is-dot');
          var dot = document.createElement('i');
          dot.style.background = col;
          fig.appendChild(dot);
        } else if (okUrl(src)) {
          var im = document.createElement('img');
          im.alt = '';
          im.loading = 'lazy';
          im.decoding = 'async';
          im.src = src;
          fig.appendChild(im);
        } else {
          fig.classList.add('is-text');
          fig.textContent = 'Aa';
        }
      }
      tag.classList.add('lg-sum');
      tag.textContent = '';
      var body = document.createElement('span');
      body.className = 'lg-sum-body';
      var k = document.createElement('span');
      k.className = 'lg-sum-k';
      k.textContent = title;
      var t = document.createElement('b');
      t.className = 'lg-sum-t';
      t.textContent = value;
      body.appendChild(k);
      body.appendChild(t);
      tag.appendChild(fig);
      tag.appendChild(body);
      tag.appendChild(edit);
    });
  }

  /* ---------- desktop: promo messages under the dock ---------- */
  function buildTicker(host) {
    if (!host || $('.lg-ticker')) return;
    var msgs = [];
    $$('.customizer-desktop-only .promotions-scroll p, .announcement-bar__text').forEach(function (n) {
      var t = n.textContent.replace(/\s+/g, ' ').trim();
      if (t && msgs.indexOf(t) < 0) msgs.push(t);
    });
    if (!msgs.length) return;
    var d = document.createElement('div');
    d.className = 'lg-ticker';
    d.innerHTML = '<span class="lg-ticker-i" aria-hidden="true"></span><span class="lg-ticker-t"></span>';
    var t = $('.lg-ticker-t', d);
    t.textContent = msgs[0];
    host.appendChild(d);
    if (msgs.length < 2) return;
    var i = 0;
    var iv = setInterval(function () {
      if (!d.isConnected) { clearInterval(iv); return; }
      if (document.hidden || !mqD.matches) return;
      addCls(t, 'is-swap');
      setTimeout(function () { i = (i + 1) % msgs.length; t.textContent = msgs[i]; delCls(t, 'is-swap'); }, 350);
    }, 4200);
  }

  /* ---------- overlay: full screen on phones, under the header on desktop ---------- */
  function fitModal() {
    var m = document.getElementById('fullscreen-modal');
    if (!m || m.style.display !== 'flex') return;
    var unit = (window.CSS && CSS.supports && CSS.supports('height', '100dvh')) ? '100dvh' : '100vh';
    var top = 0;
    if (mqD.matches) {
      ['.header', '.halo-header-mobile', '.announcement-bar'].forEach(function (sel) {
        var el = $(sel);
        if (el && el.offsetHeight > 0) top = Math.max(top, el.getBoundingClientRect().bottom);
      });
      top = Math.max(0, Math.round(top));
    }
    var tv = top + 'px', hv = 'calc(' + unit + ' - ' + top + 'px)';
    if (m.style.top !== tv) m.style.top = tv;
    if (m.style.height !== hv) m.style.height = hv;
  }
  function hookModal() {
    if (window.adjustModal && !window.adjustModal.__lg) {
      var o = window.adjustModal;
      window.adjustModal = function () {
        var r = o.apply(this, arguments);
        try { fitModal(); } catch (e) {}
        return r;
      };
      window.adjustModal.__lg = 1;
    }
    fitModal();
  }
  function watchModal() {
    var m = document.getElementById('fullscreen-modal');
    if (!m || m.__lgm) return;
    m.__lgm = 1;
    var h = document.documentElement;
    var f = once(function () {
      var open = m.style.display === 'flex';
      tgl(h, 'lg-open', open);
      if (open) fitModal();
    });
    new MutationObserver(f).observe(m, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', f);
    f();
  }

  /* ---------- phones: keep the close (X) button visible inside the promo strip ---------- */
  var placeClose = once(function () {
    var x = document.getElementById('close-modal'), m = $('.main-customizer-new'), bar = $('.customizer-desktop-only .custom_shirt');
    if (!x || !m) return;
    var want = !mqD.matches && !!bar && !!$('.promotions-scroll p', bar) && bar.offsetHeight > 0;
    if (want && x.parentNode !== bar) bar.appendChild(x);
    else if (!want && x.parentNode !== m) m.insertBefore(x, m.firstChild);
    tgl(m, 'lg-xin', want);
  });

  /* ---------- mount ---------- */
  function mount() {
    var fb = $('.fabric_box'), cc = $('.customizer_content'), sp = $('.custom_summary_page'), sz = $('.create-size');
    if (!fb || !cc || !sp || !sz) return false;
    if ($('.lg-steps')) return true;
    var pi = $('.product-image', fb);
    if (pi) {
      pi.appendChild(mkGuide('lg-guide--left'));
      pi.appendChild(build('lg-steps--left'));
      var dock = $('.button-container.desktop-only');
      if (dock) { addCls(dock, 'lg-dock'); pi.appendChild(dock); }
      buildTicker(pi);
    }
    cc.insertBefore(build('lg-steps--top'), cc.firstChild);
    sp.insertBefore(build('lg-steps--summary'), sp.firstChild);
    initSize(sz);
    groupTags(sz);
    initSearchNow();
    watchNext();
    hookModal();
    watchModal();
    hookCart();
    placeClose();
    window.addEventListener('resize', placeClose);

    var ov = $('.overview');
    if (ov) new MutationObserver(initSearch).observe(ov, { childList: true });
    var mo = new MutationObserver(paint);
    mo.observe(sp, { attributes: true, attributeFilter: ['class'] });
    mo.observe(sz, { attributes: true, attributeFilter: ['class'] });
    var enh = once(function () { enhanceSummary(); enhanceMono(); });
    ['.summary_style', '.summary_additional', '.summary_monogram'].forEach(function (sel) {
      var b = $(sel);
      if (b) new MutationObserver(enh).observe(b, { childList: true });
    });
    paintNow();
    return true;
  }

  var tries = 0;
  (function go2() {
    var ok = false;
    try { ok = mount(); } catch (e) { if (window.console) console.warn('[glass] mount', e); ok = tries > 3; }
    if (!ok && tries++ < 120) setTimeout(go2, 150);
  })();
})();
